import { capitalCase } from 'change-case'
import { useState, useEffect, useRef, forwardRef } from 'react'
import { useSnackbar } from 'notistack';
// material
import {
  Container,
  Tab,
  Box,
  Tabs,
  Stack,
  Typography,
  MenuItem,
  TextField,
  Card,
  Grid,
  Divider,
  CircularProgress,
  AvatarGroup,
  Tooltip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  AppBar,
  Toolbar,
  Slide,
  IconButton,
} from '@material-ui/core'
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles'
// components
import Posts from '../../components/projects/viewProjects/ViewTasks/Posts'
import Attachments from '../../components/projects/viewProjects/ViewTasks/Attachments'
import SubTasks from '../../components/projects/viewProjects/ViewTasks/SubTasks'
import Activities from '../../components/projects/viewProjects/ViewTasks/Activities'
import { useLocation, useNavigate, useParams } from 'react-router'
import axios from 'axios'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import AddTask from 'src/components/projects/AddTask'
import ConfirmationPopup from 'src/components/confirmationPopup';
import { PATH_DASHBOARD } from 'src/routes/paths';
import {Button} from '@material-ui/core';
import { KeyboardBackspaceOutlined, Login, Logout, TryOutlined, Close } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom'
import { truncate } from 'lodash';
import LoadingScreen from 'src/components/LoadingScreen';
import DesignOrderSubTasks from 'src/components/projects/viewProjects/ViewTasks/DesignOrderSubTasks';
import ViewDesignOrderDetails from 'src/components/_dashboard/official-request/ViewDesignOrderDetails';
import Scrollbar from 'src/components/Scrollbar';
import DesignProjectAttachment from './DesignProjectAttachment';
import EditDesignJob from './EditDesignJob';
import editFill from '@iconify/icons-eva/edit-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Icon } from '@iconify/react';

// ----------------------------------------------------------------------

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

let option = [
  { id: 1, color:'primary', value: 'New' },
  { id: 2, color:'info', value: 'In Progress' },
  { id: 3, color:'success', value: 'Completed' },
  { id: 4, color:'warning', value: 'In Testing' },
  { id: 5, color:'error', value: 'Canceled' },
  { id: 6, color:'success', value: 'Approved by Dev team' },
  { id: 7, color:'success', value: 'Approved by the client' },
  { id: 8, color:'primary', value: 'Reopen' },
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#008000',
  '#5cb85c',
  '#f0ad4e',
  '#c9302c',
  '#5cb85c',
  '#5cb85c',
  '#5bc0de',
]

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
})

export default function ViewDesignOrderTask({
  popupOn,
  postId,
  projectsId,
  taskCurrentTab,
  taskDetails,
  oDdetailsProp,
  designsProp,
  requestIdProp,
  invoiceProp,
  referenceFilesProp,
  handleBackToAlljobs,
  onProjectRefresh,
  showTaskListBack,
  openDesignOrderPopupTrigger,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate()
  const location = useLocation()
  const { id: paramsId, design_order_id, projectId: paramsProjectId } = useParams();
  const id = popupOn ? postId : paramsId;
  const projectId = popupOn ? projectsId : (paramsProjectId || design_order_id);
  const theme = useTheme()
  const ref = useRef(null)
  const designs = popupOn ? designsProp : location?.state?.designs
  const referenceFilesFromLocation = popupOn
    ? (referenceFilesProp || [])
    : (location?.state?.referenceFiles || [])
  console.log('referenceFilesreferenceFiles==',referenceFilesFromLocation)
  const currentTab = popupOn ? taskCurrentTab : location?.state?.currentTab
  const details = popupOn ? taskDetails : location?.state?.details
  console.log('detailsdetails==',details)
  const oDdetails = popupOn ? oDdetailsProp : location?.state?.oDdetails
  console.log('oDdetailsoDdetails==',oDdetails)
  const requestId = popupOn ? requestIdProp : location?.state?.requestId
  const invoice = popupOn ? invoiceProp : location?.state?.invoice

  console.log("##############CurrentTab",useLocation());
  const logo =
    'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
  const [secTab, setSecTab] = useState('SUBTASKS')
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [data,setData] = useState(null)
  const [subTasks,setSubTasks] = useState(null)
  const [projectMembers,setProjectMembers] = useState(null)
  const [isEdit,setIsEdit] = useState(false)
  const [isDelete,setIsDelete] = useState(false)
  const [fetchData,setFetchData] = useState(false)
  const [subTasksLoading, setSubTasksLoading] = useState(false)
  const [projectPosts,setProjectPosts] = useState([])
  const [refresh,setRefresh] = useState(false)
  const [options,setOptions]= useState(option)
  const [skills,setSkills] = useState([])

  const [loading, setLoading] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [openBackConfirm, setOpenBackConfirm] = useState(false)
  const [justSubmittedDesignOrder, setJustSubmittedDesignOrder] = useState(false)
  const [designOrderDetails, setDesignOrderDetails] = useState(null)
  const [oDdetails1, setDetails] = useState(null)
  const [referenceFiles, setReferenceFiles] = useState([])
  const [customerData, setCustomerData] = useState(null)
  const [oDdesigns, setDesigns] = useState([])
  const [designOrderProducts, setDesignOrderProducts] = useState([])
  const [designOrderServices, setDesignOrderServices] = useState([])
  const [allTeamMembers, setAllTeamMembers] = useState([])
  console.log('designOrderProductsdesignOrderProducts=8888',designOrderProducts)

  const user = JSON.parse(window.localStorage.getItem('user'))
  const   userId = user?.user_id
  const explodedPermissions = user?.exploded_permissions
  const viewasadmin = explodedPermissions?.some(permission => ['View Design Order as Admin'].includes(permission)) ? true : false
  const canEditDesignOrder = explodedPermissions?.some((permission) =>
    ['Edit Design Order'].includes(permission),
  )
  const designOrderId = oDdetails?.id || projectId
  const designOrderActionDetails = designOrderDetails || oDdetails1 || oDdetails || details

  const handleEditClick = () => {
    if(designOrderActionDetails?.design_order_job_status==2){
    setIsOpenEdit(true)
    }
  }
  const TABS = [
    {
      value: 'SUBTASKS',
      component: <DesignOrderSubTasks details={details} data={subTasks} loading={subTasksLoading} setFetchData={setFetchData} projectMembers={projectMembers} taskId={id} projectId={projectId} setRefresh={setRefresh} refresh={refresh} currentTab={currentTab} onProjectRefresh={onProjectRefresh} designs={designs}/>,
    },
    {
      value: 'Designs',
      component: (
        <DesignProjectAttachment
          setFetchData={setFetchData}
          projectId={projectId}
          currentTab={currentTab}
          designOrder={true}
          data={data}
        />
      ),
    },
  // {
  //   value: 'POSTS',
  //   component: <Posts projectPosts={projectPosts} taskId={Number(id)} projectId={projectId}
  //     refresh={refresh} setRefresh={setRefresh} currentTab={currentTab}/>,
  // },
  // {
  //   value: 'ATTACHMENTS',
  //   component: <Attachments taskId={Number(id)} projectId={projectId}
  //   refresh={refresh} setRefresh={setRefresh} currentTab={currentTab}/>,
  // },
  {
    value: 'SKILLS',
    component: <Activities skills={skills}/>,
  },
  // {
  //   value: 'ACTIVITIES',
  //   component: <Activities />,
  // },
  ]

  useEffect(() => {
    try {
      setSubTasksLoading(true)
      axios.post(`${REST_API_END_POINT}project/fetch-all-design-order-project-sub-task`,{
        taskId: Number(id),userType: user.user_type, userId: user.user_id
      },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setSubTasks(response.data.result)
          console.log('subtaskdataaaaaaaaaaaaaa',response.data.result)
          setSkills(response.data.skills)
        }
      
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        setSubTasksLoading(false)
        setFetchData(false)
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
        setSubTasksLoading(false)
        setFetchData(false)
      }
  }, [fetchData])

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/get-design-order-project-task-by-id`,
        { taskId: id, id:projectId,userId: user.user_id,userType: user.user_type},{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          // setProjectPosts(response.data.projectPost)
          setData(response.data.result[0])
          setProjectMembers(response.data.projectMembers)
         
          // Assume 'statusValue' is the value you want to filter by

       option = option.filter(opt => opt.id=== response.data.result[0].status);
       setOptions(option)
         
        }
      
      }).catch((error) => {
        console.error(error);
      })
      // handleFetchEditData(id)
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [isEdit,refresh])

  useEffect(() => {
    if(data?.status){
      setValue(option.find(opt=>opt.id === data.status))
    }
  }, [data])

  const fetchTeamMembersForCollaborators = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: user.user_type,
        isClient: user.isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setAllTeamMembers(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
    }
  }
  useEffect(() => {
    if (userId) {
      fetchTeamMembersForCollaborators();
    }
  }, []);

  const handleUpdateStatus = (status)=>{
    try {
      axios.post(`${REST_API_END_POINT}project/update-project-task-status`,{ taskId: id, status, userId: user.user_id },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          setValue(option.find(opt=>opt.id === status))
          enqueueSnackbar(response.data.message, { variant: 'success' });
        }else if(response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
      
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleDeleteTask = ()=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/delete-project-task`,{ id: Number(id),projectId, status: 0 },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4){
          enqueueSnackbar(response.data.message, { variant: 'success' });
          if (popupOn && typeof handleBackToAlljobs === 'function') {
            handleBackToAlljobs()
          } else {
            navigate(PATH_DASHBOARD.design.viewDesignOrderProject+projectId)
          }
        }else if(response.data.status === 5){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleTab = (event, newValue) => {
    setSecTab(newValue)
  }

  const fetchRequestDetails = async () => {
    const orderId = oDdetails?.id || projectId
    if (!orderId) return
    setLoading(true)
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}design/get-design-order-by-id`,
        {
          design_order_id: orderId,
          userId: user.user_id,
          userType: viewasadmin ? 1 : user.user_type,
        },
      )
      res.data
      setCustomerData(res.data.customerData)
      const orderData = res.data?.data?.[0] || null
      setDesignOrderDetails(orderData)
      setDetails({
        ...orderData,
        projectMembers: res.data?.projectMembers || []
      });
      setDesigns(res.data.attachments)
      setDesignOrderProducts(res.data?.productsData || [])
      setDesignOrderServices(res.data?.servicesData || [])
      if (res.data?.reference_attachments) {
        setReferenceFiles((res.data.reference_attachments || []).map((att) => ({ ...att, name: att.file_url || att.name })))
      } else {
        setReferenceFiles([])
      }
      setRefresh(false)
    } catch (error) {
      console.error('Error fetching request details:', error)
    } finally {
      setLoading(false)
    }
  }
    console.log('detailsdetailsdetails==', details);
useEffect(() => {
  const getRequestDetails = async () => {
    if (projectId || oDdetails?.id) {
      await fetchRequestDetails();
    }
  };

  getRequestDetails();
}, [projectId, oDdetails?.id, refresh]);

  // Auto-open Edit Design Order on load disabled — open only via Edit Design Order button click
  // useEffect(() => {
  //   const order = designOrderDetails || oDdetails
  //   if (
  //     canEditDesignOrder &&
  //     !justSubmittedDesignOrder &&
  //     order &&
  //     order?.status !== 0 &&
  //     order?.hold != 1 &&
  //     order?.design_order_job_status != 3
  //   ) {
  //     handleEditClick()
  //   }
  // }, [designOrderDetails, oDdetails])  
    useEffect(() => {
      if (!popupOn || !openDesignOrderPopupTrigger) return
      if (designOrderActionDetails?.design_order_job_status == 2) {
        setIsOpenEdit(true)
      }
    }, [openDesignOrderPopupTrigger])

console.log('detailsdetails-=',oDdetails)

  const Wrapper = popupOn ? Box : Container
  const wrapperProps = popupOn ? { sx: { width: '100%', p: 0 } } : {}

  return (
    <Wrapper {...wrapperProps}>
      {/* {loading ? 
        <LoadingScreen sx={{ top: 0, left: 0, width: 1, zIndex: 9999, position: 'fixed' }} />
      :
        <> */}
          {!popupOn && (
            <Stack justifyContent='space-between' flexDirection='row'>
              <Button
                variant="outlined"
                type="submit"
                component={RouterLink}
                to={PATH_DASHBOARD.design.viewDesignOrderProject+projectId}
                state={{currentTab:currentTab}}
                sx={{ alignItems: 'flex-end', mb: 3.5 }}
                startIcon={
                  <Stack>
                    <KeyboardBackspaceOutlined/>
                  </Stack>
                }
              >
                Back to Job Details
              </Button>
            </Stack>
          )}
          {popupOn && showTaskListBack && typeof handleBackToAlljobs === 'function' && (
            <Stack justifyContent='flex-start' flexDirection='row' sx={{ mb: 1 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleBackToAlljobs}
                startIcon={
                  <Stack>
                    <KeyboardBackspaceOutlined/>
                  </Stack>
                }
              >
                All Tasks
              </Button>
            </Stack>
          )}
          {!popupOn && (
            <Box sx={{ width: '100%', mb: 4 }}>
              <Card sx={{ width: '100%', height:300, pb: 4 }}>
                <Typography variant="h4" textAlign='center' gutterBottom sx={{ backgroundColor:theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.grey[800],borderBottom: `1px solid ${theme.palette.divider}`,}}>
                  Order Details
                </Typography>
                <Scrollbar>
                  <ViewDesignOrderDetails
                    teamMembers={[]}
                    clientDetails={oDdetails}
                    products={[]}
                    fetchRequestDetails={fetchRequestDetails}
                    user={user}
                    designs={designs}
                    referenceFiles={referenceFiles.length > 0 ? referenceFiles : referenceFilesFromLocation}
                    setDesigns={setDesigns}
                    details={oDdetails}
                    isRequest={true}
                    requestId={requestId}
                    invoice={invoice}
                    isDesign={true}
                    isFromTask={true}
                    designOrderProducts={designOrderProducts}
                    designOrderServices={designOrderServices}
                    allTeamMembers={allTeamMembers}
                  />
                </Scrollbar>
              </Card>
            </Box>
          )}
          <Stack spacing={popupOn ? 2 : 5}>
            <Stack
              // direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{
                background: theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.grey[800],
                borderRadius: 2,
                boxShadow: theme.palette.mode === 'light'
                  ? '0px 0px 8px rgba(0, 0, 0, 0.12)'
                  : 'none',
                color: theme.palette.text.primary,
              }}
            >
              <Grid container justifyContent={'center'}>
                <Grid item xs={12} pt={popupOn ? 1 : 4}>
                  <Stack spacing={popupOn ? 2 : 3}>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={popupOn ? 1 : 3}
                      justifyContent={'space-between'}
                    >
                       <Typography variant={popupOn ? 'h5' : 'h4'} >{data?.name}</Typography>
                       {designOrderActionDetails?.design_order_job_status==2 && (
                      <Button
                        variant='contained'
                        onClick={() => {
                          handleEditClick()
                        }}
                        startIcon={<Icon icon={designOrderActionDetails?.is_create_design_order == 1 ? editFill : plusFill} width={20} height={20} />}
                      >
                        {designOrderActionDetails?.is_create_design_order == 1 ? 'Edit Design Order' : 'Create Design Order'}
                      </Button>
                      )}
                      {/* <TextField
                        select
                        size="small"
                        value={value.value}
                       
                        sx={{
                          minWidth: { lg: '30%', md: '50%', sm: '40%' },
                          background: colors[value.id],
                          color:'blue',
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                     
                      >
                        {console.log("################OPtion",option)}
                        {options.map((optio) => (
                          <MenuItem
                            // onClick={() => {
                            //   handleUpdateStatus(optio.id)
                            //   setValue(optio)
                            // }}
                            key={optio.value}
                            value={optio.value}
                          >
                            {optio.value}
                          </MenuItem>
                        ))}
                          
                      </TextField> */}
                    </Stack>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                      {/* <Stack direction={'row'} spacing={1}> */}
                      {/* <Typography variant="subtitle2">{data?.member_count} Members</Typography> */}
                      {/* <Typography variant="subtitle2">{data?.file_count} Attachments</Typography> */}
                      {/* </Stack> */}
                      {/* <Box sx={{mb: -2}}>
                      { (user.user_type !== 3 && currentTab!="Installations" && currentTab!="Completed" && currentTab!="Hold") &&
                      <UserMoreMenu onDelete={()=>setIsDelete(true)} onEdit={()=>setIsEdit(true)}/>
                      }
                      </Box> */}
                    </Stack>
                    <Box sx={{ display: 'flex',justifyContent:'flex-start', alignItems: 'center',}}>
              <Stack>    
              <Typography variant="subtitle2">
                   Job Members
                    </Typography>             
                    <AvatarGroup max={4}>
                     {projectMembers?.map((row)=>( 
                        <Tooltip key={row.id} title={row.name}>             
                      <Avatar src={row.profile_pic} alt={row.name} />
                      </Tooltip>                   
                     ))}
                    </AvatarGroup>
                  </Stack>
              </Box>
                    <Divider />
                    <Tabs
                      value={secTab}
                      scrollButtons="auto"
                      variant="scrollable"
                      allowScrollButtonsMobile
                      onChange={handleTab}
                    >
                      {TABS.map((tab) => (
                        <Tab
                          disableRipple
                          key={tab.value}
                          label={
                            <Typography variant="overline">
                              {capitalCase(tab.value)}
                            </Typography>
                          }
                          icon={tab.icon}
                          value={tab.value}
                        />
                      ))}
                    </Tabs>
                    </Stack>
                </Grid>
              </Grid>
            </Stack>
            <Stack sx={{ alignItems: 'center', mb: popupOn ? 1 : 2 }} spacing={popupOn ? 1 : 2}>
              {TABS.map((tab) => {
                const isMatched = tab.value === secTab
                return (
                  isMatched && (
                    <Box sx={{ width: popupOn ? '100%' : '75%' }} key={tab.value}>
                      {tab.component}
                    </Box>
                  )
                )
              })}
            </Stack>
          </Stack>
          {/* <AddTask data={data} setData={setData} projectMembers={projectMembers} projectId={Number(data?.project_id)} add={isEdit} setAdd={setIsEdit} refresh={refresh} setRefresh={setRefresh} designOrder={true}/> */}
          <ConfirmationPopup open={isDelete} handleClick={handleDeleteTask} message={'Want to Delete This Task'} handleClose={()=>setIsDelete(false)}/>

      <Dialog fullScreen open={isOpenEdit} TransitionComponent={Transition}>
        <AppBar position="relative" sx={{ mb: 1 }}>
          <Toolbar sx={{ minHeight: '48px !important', py: 0.5 }}>
            <Typography variant="subtitle1" sx={{ flex: 1, ml: 1, fontSize: '1rem' }}>
              Edit Design Order
            </Typography>
            <Close
              onClick={() => setOpenBackConfirm(true)}
              sx={{ fontSize: '1.8rem', cursor: 'pointer' }}
            />
          </Toolbar>
        </AppBar>
        {isOpenEdit && designOrderId ? (
          <EditDesignJob
            popupOn
            designOrderId={designOrderId}
            closeView={() => setIsOpenEdit(false)}
            onSaveComplete={() => {
              setJustSubmittedDesignOrder(true)
              setDesignOrderDetails((prev) => ({
                ...(prev || designOrderActionDetails || {}),
                is_create_design_order: 1,
              }))
              setDetails((prev) => ({
                ...(prev || designOrderActionDetails || {}),
                is_create_design_order: 1,
              }))
              setRefresh((prev) => !prev)
              fetchRequestDetails()
              if (typeof onProjectRefresh === 'function') {
                onProjectRefresh()
              }
            }}
          />
        ) : null}
      </Dialog>

      <Dialog open={openBackConfirm} onClose={() => setOpenBackConfirm(false)}>
        <DialogTitle>Close without saving?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your changes may be lost. Close the editor?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenBackConfirm(false)
              setIsOpenEdit(false)
            }}
            color="inherit"
          >
            Close
          </Button>
          <Button onClick={() => setOpenBackConfirm(false)} color="primary" variant="contained">
            Keep editing
          </Button>
        </DialogActions>
      </Dialog>
        {/* </>
      } */}
    </Wrapper>
  )
}
